import {Component, OnInit, ViewChild} from '@angular/core';
import {ProgressBarComponent} from "../../components/progress-bar/progress-bar.component";
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Questions} from '../../domain/questions';
import {QuestionService} from '../../services/question.service';
import {ScoreService} from '../../services/score.service';
import {Score} from '../../domain/score';

@Component({
  selector: 'tech-core-quiz-question',
  standalone: false,
  templateUrl: './question.component.html',
  styleUrl: './question.component.scss'
})
export class QuestionComponent implements OnInit{
  @ViewChild(ProgressBarComponent) progressBar!: ProgressBarComponent;

  questionForm: FormGroup;
  questions: Questions[] = [];
  currentQuestionIndex: number = 0;
  selectedAnswer: string | null = null;
  isCorrect: boolean | null = null;
  totalScore: number = 0;
  username: string = "TestUser";
  isAnswered: boolean = false;
  feedbackMessage: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private questionService: QuestionService,
    private scoreService: ScoreService,
  ) {
    this.questionForm = this.fb.group({});
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.username = params['username'];
      console.log("Received Username:", this.username);
    });
    this.loadQuestions();
  }

  loadQuestions() {
    this.questionService.getQuestionsShuffled().subscribe({
      next: (data) => {
        const shuffledQuestions = this.shuffleArray(data);

        this.questions = shuffledQuestions.map(question => ({
          ...question,
          answers: this.shuffleArray([...question.answers])
        }));
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  shuffleArray(array: any[]) {
    return array.sort(() => Math.random() - 0.5);
  }

  selectAnswer(answer: string) {
    if (!this.isAnswered) {
      this.selectedAnswer = answer;
      this.isCorrect = answer === this.questions[this.currentQuestionIndex].correct_answer;
      this.isAnswered = true;

      // Stop the timer and get remaining time
      const remainingTime = this.progressBar.stopProgress();

      // Calculate points: 10 for correct answer + remaining seconds
      if (this.isCorrect) {
        const correctResponses = ["Good job, that is correct!", "That's correct!", "Well done!"];
        this.feedbackMessage = correctResponses[Math.floor(Math.random() * correctResponses.length)];
        this.totalScore += 10 + remainingTime;
      } else {
        this.feedbackMessage = `Too bad, the corrrect answer was: <br> ${this.questions[this.currentQuestionIndex].correct_answer}`;
      }

      console.log(`User: ${this.username}, Question: ${this.currentQuestionIndex + 1}, Answer: ${answer}, Correct: ${this.isCorrect}, Score: ${this.totalScore}`);
    }
  }

  nextQuestion() {
    if (this.currentQuestionIndex < this.questions.length - 1) {
      this.currentQuestionIndex++;
      this.selectedAnswer = null;
      this.isCorrect = null;
      this.isAnswered = false;
      this.progressBar.restartProgress();
      this.feedbackMessage = '';
    } else {
      console.log(`Quiz Finished! User: ${this.username}, Final Score: ${this.totalScore}`);
      this.scoreService.createScore(this.username, this.totalScore.toString()).subscribe({
        next: (data) => {
          const now = new Date().getTime();
          localStorage.setItem('quizCooldown', now.toString());
          this.router.navigate(['/quiz-done'], {queryParams: {userName: this.username,}});
        },
        error: (err) => {
          console.error(err);
        }
      });
    }
  }

  handleTimeOut() {
    if (!this.isAnswered) {
      this.isAnswered = true;
      this.selectedAnswer = null;
      this.isCorrect = false;
      const correctAnswer = this.questions[this.currentQuestionIndex].correct_answer;
      this.feedbackMessage = `Time ran out, the answer was:  <br> ${correctAnswer}`;
      console.log(`User: ${this.username}, Question: ${this.currentQuestionIndex + 1}, Answer: Time ran out, Correct: ${this.isCorrect}, Score: ${this.totalScore}`);
    }
  }

}
